import * as React from 'react';
import { Top3Reviews, ITop3ReviewsContext } from '@cian/top3-reviews-widget';
import { Layout } from '../Layout';
import * as styles from './reviews.css';

export interface IReviewsProps {
  context?: ITop3ReviewsContext;

  reviewsCount?: number | null;

  onAnswerClick(): void;
  onAnswerSucceed(reviewId: string, answerId: string, subscribe: boolean): void;
  onDislikeReview(): void;
  onHeaderReviewsLinkClick(): void;
  onLikeReview(): void;
  onReviewClick(): void;
  // tslint:disable-next-line:variable-name
  onReviewSucceed(_reviewId: string, subscribe: boolean): void;
  onSubscribed(): void;
  onSubscribePopupOpen(): void;
  onUnsubscribed(): void;
  onViewAllReviewsLinkClick(): void;
  onViewFullReviewClick(): void;
}

export const Reviews: React.StatelessComponent<IReviewsProps> = props => {
  if (!props.context) {
    return null;
  }

  const { reviewsCount, ...restProps } = props;

  return (
    <div className={styles['reviews']}>
      <Layout>
        <div data-nav-tab="reviews/Отзывы" id="reviews" className={styles['nav_container']}>
          <Top3Reviews
            context={props.context}
            deviceType="desktop"
            onAuthenticationRequest={
              /* istanbul ignore next */
              () => {
                /* istanbul ignore next */
                window.location.href = `/authenticate/?redirect_url=${encodeURIComponent(window.location.href)}`;
              }
            }
            {...restProps}
          />
        </div>
      </Layout>
    </div>
  );
};
